import { Box } from '@mui/material';
import styled from 'styled-components';

interface StyledProgressProps {
  $progress: number;
}

export const StyledProgress = styled(Box)<StyledProgressProps>`
  position: relative;

  .input {
    width: inherit;
    height: inherit;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    > div {
      margin-bottom: 0;

      .MuiInputBase-root {
        background-color: transparent;
        border: none !important;
        padding-left: 0 !important;
        position: relative;
        height: 40px;

        &::after {
          content: '%';
          position: absolute;
          right: 122px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 14px;
          font-weight: 600;
          line-height: 21px;
          color: ${({ $progress }) =>
            $progress > 55 ? 'var(--color-white)' : 'var(--color-primary-blue)'} !important;
        }

        > input {
          text-align: center;
          background-color: transparent;
          font-size: 14px;
          font-weight: 600;
          line-height: 21px;
          padding-left: 20px;
          color: ${({ $progress }) =>
            $progress > 48 ? 'var(--color-white)' : 'var(--color-primary-blue)'} !important;
          caret-color: var(--color-primary-blue);

          &:disabled {
            color: var(--color-white) !important;
            background-color: transparent;
            -webkit-text-fill-color: var(--color-white) !important;
          }
        }

        &:hover {
          border: none !important;
          box-shadow: none !important;
        }
      }
    }

    /* .MuiOutlinedInput-root.Mui-disabled {
      color: var(--color-white) !important;
    }

    .MuiOutlinedInput-root .MuiOutlinedInput-input:disabled {
      -webkit-text-fill-color: var(--color-white) !important;
    } */
  }
`;
